export const FORCED_LOGOUT = 'forced_logout';
